import { render, staticRenderFns } from "./user-layout.vue?vue&type=template&id=f645322e&scoped=true"
import script from "./user-layout.vue?vue&type=script&lang=js"
export * from "./user-layout.vue?vue&type=script&lang=js"
import style0 from "./user-layout.vue?vue&type=style&index=0&id=f645322e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f645322e",
  null
  
)

export default component.exports